import { Space, Tag, Typography } from 'antd'
import { ProjectType, projectTypeName } from '../../../common/constants'
import VSpace from '../../common/VSpace'
import { ReportFilterViewModel } from '../datacenterModel'
import ReportFilterDateDetails from '../ReportFilterDateDetails'

const { Text } = Typography

type Props = {
  filterItem: ReportFilterViewModel
}

const EstimateReportFilterDetails = ({ filterItem }: Props) => {
  return <VSpace>
    <ReportFilterDateDetails filterItem={filterItem} />
    <Space wrap>
      {'searchTerm' in filterItem.filters && filterItem.filters.searchTerm && <Text type='secondary'>Search Term: {filterItem.filters.searchTerm}</Text>}
      {'archived' in filterItem.filters && <Text type='secondary'>Visibility: {filterItem.filters.archived ? 'Archived' : 'Active'}</Text>}
    </Space>
    <Space wrap>
      {'salesPersonIds' in filterItem.filters && filterItem.filters.salesPersonIds.map((id, index) => <Tag key={index}>{id}</Tag>)}
    </Space>
    <Space wrap>
      {'projectTypeIds' in filterItem.filters && filterItem.filters.projectTypeIds.map((id, index) => <Tag color='blue' key={index}>{projectTypeName(id as ProjectType)}</Tag>)}
    </Space>
    <Space wrap>
      {'divisionIds' in filterItem.filters && filterItem.filters.divisionIds.map((id, index) => <Tag color='orange' key={index}>{id}</Tag>)}
    </Space>
  </VSpace>
}

export default EstimateReportFilterDetails
